<template>
  <div class="file">
    <a :href="url" :target="target" class="file__btn">
      <font-awesome-icon :icon="icon" size="2x" />
      {{ heading }}
    </a>
  </div>
</template>

<script>
export default {
  name: "File",
  props: ["url", "target", "icon", "heading"]
};
</script>

